import { useState, useEffect, useCallback, memo, useMemo } from 'react';
import { getScrollbarWidth } from '../../GlobalFunc';
import './toast.scss';

const ToastContainer = ({ style, children, isOTP, isRs, isRacingClear }) => {
    const scrollbarWidth = useMemo(() => {
        return getScrollbarWidth()
    }, [])
    return (
        <>
            {isOTP ? (
                <div className="toast-otp-fixed" style={style}>
                    <div className="reset">
                        <div>{children}</div>
                    </div>
                    <div className="reset"></div>
                </div>
            ) : isRs ? (
                <div className="main-content toast-fixed toast-fixed-isRs" style={{...style, "--scrollbarWidth": `${scrollbarWidth}px`}}>
                    <div className="left-content reset">
                        <div className="leftMenuMain"></div>
                        <div className="toast-con">{children}</div>
                    </div>
                    <div className="betslip-container reset"></div>
                </div>
            ) : (
                <div className={`main-content toast-fixed ${isRacingClear ? 'toast-racing-clear-fixed' : ''}`} style={style}>
                    <div className="left-content reset">
                        <div className="toast-con">{children}</div>
                    </div>
                    <div className="betslip-container reset"></div>
                </div>
            )}
        </>
    );
};

const ToastItem = ({ state = 'successful', message = 'successful', showTime, id, onExit, isOTP, isRs, button, alignCenter }) => {
    const [show, setShow] = useState(true);
    useEffect(() => {
        let ref;
        if (showTime) {
            ref = setTimeout(() => {
                setShow(false);
            }, showTime);
        }
        return () => {
            clearTimeout(ref);
        };
    }, [id]);

    useEffect(() => {
        if (show === false) {
            onExit(id);
        }
    }, [show, onExit]);

    return show ? (
        <div
            className={` ${isOTP ? `toastResultMeassage-otp` : `toastResultMeassage`} ${
                isRs ? `toastResultMeassage-isRs` : ``
            } ${
                alignCenter ? `toastResultMeassage-alignCenter` : ``
            } successful ${state}`}
            style={{ '--showTime': `${showTime / 1000}s` }}
        >
            {state === 'successful' && (
                <>
                    <div className="icon-status-accepted toastMsgIcon"></div>
                    <span className="successfulText">{message}</span>
                </>
            )}
            {state === 'warning' && (
                <>
                    <div className="icon-status-warning toastMsgIcon"></div>
                    <span className="successfulText rejectColor">{message}</span>
                </>
            )}
            {state === 'rejected' && (
                <>
                    <div className="icon-status-rejected toastMsgIcon"></div>
                    <span className="successfulText rejectColor">{message}</span>
                </>
            )}
            {state === 'liteWarning' && (
                <>
                    <div className="icon-status-liteWarning toastMsgIcon"></div>
                    <span className="successfulText rejectColor">{message}</span>
                </>
            )}
            <div className="toastResultMeassage-isRs-button-con">{button}</div>
        </div>
    ) : null;
};

const MemoToastItem = memo(ToastItem);

const Toast = () => {};

export default Toast;

const useToast = ({ style = {}, max = Infinity, showTime = 3000, isOTP = false, isRs, isRacingClear = false } = {}) => {
    const [toastItem, setToastItem] = useState([]);

    const onExit = useCallback(
        (key) => {
            setToastItem([
                ...toastItem.filter((i) => {
                    return String(i.key) != key;
                })
            ]);
        },
        [toastItem]
    );

    const toastApi = useCallback(
        ({ state = 'successful', message = 'successful', showTime: itemShowTime, button, alignCenter } = {}) => {
            if (toastItem.length < max) {
                const key = Math.random();
                setToastItem([
                    ...toastItem,
                    {
                        showTime: itemShowTime ?? showTime,
                        state,
                        message,
                        key,
                        id: key,
                        button,
                        alignCenter
                    }
                ]);
            }
        },
        [toastItem]
    );
    return [
        toastApi,
        <ToastContainer
            style={{
                ...style
            }}
            isOTP={isOTP}
            isRs={isRs}
            isRacingClear={isRacingClear}
        >
            {toastItem.map((item) => (
                <MemoToastItem {...item} onExit={onExit} isOTP={isOTP} isRs={isRs} />
            ))}
        </ToastContainer>,
        setToastItem
    ];
};

const useMobileToast = ({ style = {}, max = 3, showTime = 3000, className = '' } = {}) => {
    const [toastItem, setToastItem] = useState([]);

    const onExit = useCallback(
        (key) => {
            setToastItem([
                ...toastItem.filter((i) => {
                    return String(i.key) != key;
                })
            ]);
        },
        [toastItem]
    );

    const toastApi = useCallback(
        ({ state = 'successful', message = 'successful' } = {}) => {
            if (toastItem.length < max) {
                let key = Math.random();
                setToastItem([
                    ...toastItem,
                    {
                        showTime,
                        state,
                        message,
                        key,
                        id: key
                    }
                ]);
            } else {
                let key = Math.random();
                setToastItem([
                    {
                        showTime,
                        state,
                        message,
                        key,
                        id: key
                    }
                ]);
            }
        },
        [toastItem]
    );

    return [
        toastApi,
        <div className={`mobileToast ${className}`} style={{ ...style }}>
            {toastItem.map((item) => (
                <MemoToastItem {...item} onExit={onExit} />
            ))}
        </div>
    ];
};

Toast.useToast = useToast;
Toast.useMobileToast = useMobileToast;

export { Toast };
